'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z' });

var LocalBar = function LocalBar(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

LocalBar = (0, _pure2.default)(LocalBar);
LocalBar.muiName = 'SvgIcon';

exports.default = LocalBar;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/LocalBar.js
// module id = 2557
// module chunks = 0